import baseUrl from "../baseUrl";

// Ф2: същият механизъм се ползва и за CSV архива, затова тялото е отделено.
// Заявката иска Bearer токен — затова файлът НЕ може да се свали с обикновен
// линк и минава през fetch + blob.
export const downloadFile = async (url, filename, errorMessage) => {
    const serializedAuth = localStorage.getItem('auth');
    const headers = {};

    if (serializedAuth) {
        const auth = JSON.parse(serializedAuth);
        if (auth.token) {
            headers['Authorization'] = `Bearer ${auth.token}`;
        }
    }

    const response = await fetch(`${baseUrl()}${url}`, {headers});

    if (!response.ok) {
        throw new Error(errorMessage || 'Свалянето не успя.');
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
};

export const downloadPdf = (url, filename) =>
    downloadFile(url, filename, 'PDF генерирането не успя.');
